export default "/react/logoBigData-2d3a1713.png";